import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Link from 'gatsby-link'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Drawer from '@material-ui/core/Drawer'
import Divider from '@material-ui/core/Divider'
import IoAndroidMenu from 'react-icons/lib/io/android-menu'
import ArrowDown from 'react-icons/lib/md/arrow-drop-down'
import ArrowRight from 'react-icons/lib/fa/angle-right'

const styles = (theme) => ({
  burgerMenuIcon: {
    position: 'relative',
    left: 10,
    fontSize: '2em',
    cursor: 'pointer',
    // background: theme.palette.secondary.dark,
    borderRadius: 3,
    transition: 'background 0.5s',
    '&:hover': {
      background: theme.palette.primary.main,
      color: '#fff !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.6em',
    },
  },
  burgerMenuCaption: {
    display: 'inline-block',
    marginLeft: 12,
    fontWeight: 300,
    fontSize: '0.7em',
    textTransform: 'uppercase',
    '&:hover': {
      opacity: 1,
    },
  },
  drawerContainer: {},
  drawerHeader: {
    color: '#fff',
    padding: 8,
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    fontWeight: 300,
    background: theme.palette.primary.main,
    textTransform: 'uppercase',
  },
  drawerMainNavContainer: {
    minWidth: 200,
    display: 'block',
    fontSize: '0.8em',
    padding: 5,
    '&:hover': {
      // background: theme.palette.primary.main,
      '& > a': {
        // color: '#fff',
        '&:hover': {
          color: theme.palette.link.main,
        },
      },
    },
  },
  drawerMainNavLink: {
    margin: '0 6px',
    padding: '7px 0',
    textTransform: 'uppercase',
    color: theme.palette.link.nav,
    fontSize: '0.9em',
    fontWeight: 500,
  },
  drawerSecondaryNavLinkContainer: {
    padding: 11,
    paddingLeft: 20,
    fontSize: '0.8em',
    '&:hover': {
      background: theme.palette.primary.main,
      '& > svg': {
        fill: '#fff',
      },
      '& > p:first-child': {
        color: theme.palette.link.hoveringOnSecondary,
      },
      '& > a:first-child': {
        color: theme.palette.link.hoveringOnSecondary,
      },
      '& > a.drawerSecondaryChildNavLink': {
        color: theme.palette.text.lighter,
        '&:hover': {
          color: theme.palette.link.hoveringOnSecondary,
        },
        '& > svg': {
          color: '#fff',
        },
      },
    },
  },
  drawerSecondaryChildrenNavLink: {
    paddingTop: 6,
    fontSize: '0.9em',
    color: theme.palette.text.soft,
    '&:hover': {
      color: '#74d5ff',
    },
  },
})

class Mobile extends React.Component {
  state = { open: false }

  toggleMenu = () => this.setState({ open: !this.state.open })

  render() {
    const { classes, routes, light } = this.props
    const { state } = this
    return (
      <div>
        <IoAndroidMenu
          className={classes.burgerMenuIcon}
          onClick={this.toggleMenu}
          style={{ color: light ? '#fff' : '#000' }}
        />
        <Typography
          variant="caption"
          className={classes.burgerMenuCaption}
          style={{
            color: light ? '#fff' : '#000',
          }}
        >
          Main Menu
        </Typography>
        <Drawer open={state.open} onClose={this.toggleMenu}>
          <div className={classes.drawerContainer} onKeyDown={this.toggleMenu}>
            <Typography className={classes.drawerHeader} variant="caption">
              <IoAndroidMenu
                className={classes.burgerMenuIcon}
                onClick={this.toggleMenu}
              />
              &nbsp;&nbsp;&nbsp; Main Menu
            </Typography>
            <div className={classes.drawerMainNavContainer}>
              {routes.main.map(({ to, label }, i) => (
                <Fragment key={i + to}>
                  <Typography
                    key={`mobile__main_route${i}`}
                    className={classes.drawerMainNavLink}
                    component={Link}
                    to={to}
                    onClick={this.toggleMenu}
                  >
                    {label}
                  </Typography>
                  <Divider />
                </Fragment>
              ))}
            </div>
            {routes.secondary.map(({ to, label, children }, i) => {
              const otherProps = {}
              if (to) {
                otherProps.component = Link
                otherProps.to = to
                otherProps.onClick = this.toggleMenu
              }
              return (
                <Fragment key={`secondary_nav_link${i}`}>
                  <Typography
                    component="div"
                    className={classes.drawerSecondaryNavLinkContainer}
                  >
                    <Typography
                      style={{
                        display: 'inline-block',
                        width: to ? '100%' : null,
                      }}
                      {...otherProps}
                    >
                      {label}
                    </Typography>
                    {children && (
                      <Fragment>
                        <ArrowDown
                          style={{
                            transform: 'scale(1.3)',
                            position: 'relative',
                            bottom: 1,
                            fontSize: '1.8em',
                          }}
                        />
                        <Divider style={{ marginBottom: 6 }} />
                        {children.map((childrenProps) => (
                          <Typography
                            key={childrenProps.to}
                            className={cx(
                              classes.drawerSecondaryChildrenNavLink,
                              'drawerSecondaryChildNavLink',
                            )}
                            component={Link}
                            to={childrenProps.to}
                            onClick={this.toggleMenu}
                          >
                            <ArrowRight
                              style={{
                                position: 'relative',
                                top: -3,
                                transform: 'scale(1.2)',
                              }}
                            />{' '}
                            {childrenProps.label}
                          </Typography>
                        ))}
                      </Fragment>
                    )}
                  </Typography>
                  <Divider />
                </Fragment>
              )
            })}
          </div>
        </Drawer>
      </div>
    )
  }
}

Mobile.propTypes = {
  classes: PropTypes.object.isRequired,
  routes: PropTypes.shape({
    main: PropTypes.arrayOf(PropTypes.object).isRequired,
    secondary: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  light: PropTypes.bool,
}

export default withStyles(styles)(Mobile)



// WEBPACK FOOTER //
// ./src/components/Navigation/Mobile.js